import { graphql } from 'react-relay';

export const contactFormFragment = graphql`
    fragment ContactForm_contactForm on ContactForm {
        header
        text
        formItems {
            __typename

            ... on FormItemGroup {
                title
                items {
                    __typename
                    
                    ... on RadioGroup {
                        name
                        options {
                            value
                            label
                            attached {
                                __typename
                                ... on SingleLineText {
                                    name
                                    label
                                    required
                                    special
                                }
                                ... on MultiLineText {
                                    name
                                    label
                                    required
                                }
                            }
                        }
                        required
                    }

                    ... on SingleLineText {
                        name
                        label
                        required
                        special
                    }

                    ... on MultiLineText {
                        name
                        label
                        required
                    }
                }
            }

            ... on RadioGroup {
                name
                options {
                    value
                    label
                    attached {
                        __typename
                        ... on SingleLineText {
                            name
                            label
                            required
                            special
                        }
                        ... on MultiLineText {
                            name
                            label
                            required
                        }
                    }
                }
                required
            }

            ... on SingleLineText {
                name
                label
                required
                special
            }

            ... on MultiLineText {
                name
                label
                required
            }
        }
        submitButtonLabel
    }
`;
